offcanvas.toggleSearch = function() {
	$("#search-container").toggleClass("visible");
	$(document.body).toggleClass("with-search-visible");
	$("#toggler-search").toggleClass("pressed");
};

offcanvas.isSearchVisible = function() {
	$("#search-container").is(".visible");
};

// Test only
/*
$(function() {
	$("#search-container input").focus(function() {
		$("#search-container").addClass("with-list");
		$(document.body).addClass("unscrollable");
	}).blur(function () {
		$("#search-container").removeClass("with-list");
		$(document.body).removeClass("unscrollable");
	});
})
*/

// Swipe to cancel, icon to close
$(function() {
	$("#search-bar").swipe({
		swipeUp: function() {
			offcanvas.aniToggleSearch();
		}
	});
	$("#search-close").on("click", function() {
		offcanvas.toggleSearch();
		return false;
	});
});


$.fn.aniMobileSearchBar = function(autocompleteDiv, pathShared) {
	
	var _this = this;

	var initAutocomplete = function() {
		var $input = $(this);
		if ($input.is(".ui-autocomplete-input") || !$input.autocomplete) return;
		$(this).autocomplete({
			"source": "mod-hledej-autocomplete.html",
			"delay":500,
			"appendTo": autocompleteDiv,
			"minLength":3,
			"open": function() {
				spinner(false);
				$("#search-container").addClass("with-list");
				$("#search-list").find(".ui-autocomplete").css("position", "static");
				$(document.body).addClass("unscrollable");				
			},
			"close": function() {
				$("#search-container").removeClass("with-list");
				$(document.body).removeClass("unscrollable");
			},
			"search": function() {
				spinner(true);
			},
			"response": function() {
				spinner(false);
			},
			"select": function() {
				spinner(true);
				window.setTimeout(function() {
					$input.closest("form").submit(); 
				}, 500);
			}
		});
	};

	var spinnerTimeout;
	var spinner = function(start) {
		var $icon = $(_this).find(".fa.icon");
		if (start) {
			$icon.addClass("fa-spinner fa-pulse");
			if (spinnerTimeout) {
				window.clearTimeout(spinnerTimeout);
			}
			spinnerTimeout =  window.setTimeout(function() {
				spinner(false);
			}, 2000);
		} else {
			$icon.removeClass("fa-spinner fa-pulse");
			if (spinnerTimeout) {
				window.clearTimeout(spinnerTimeout);
			}			
		}
	}

	this.find("form").submit(spinner);

	this.find(".search-input").on("click focus", function() {

		var $input = $(this);

		if ($input.is(".ui-autocomplete-input")) return;

		if ($().autocomplete) {
			initAutocomplete.call($input);
		} else {
			var scr = document.createElement("script");
			scr.src = pathShared+"jquery.ui.js";
			document.head.appendChild(scr);
			scr.onload = function() {
				initAutocomplete.call($input);	
			};			
			var scr2 = document.createElement("script");
			scr2.src = pathShared+"jquery.ui.autocomplete.js";
			document.head.appendChild(scr2);
			scr2.onload = function() {
				initAutocomplete.call($input);	
			};
		}

	});


	return this;
};